/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const WhisperEventState = {
    AUDIO_LANGUAGE_NOT_PERSISTED: 'AUDIO_LANGUAGE_NOT_PERSISTED',
    CC_LANGUAGE_NOT_PERSISTED: 'CC_LANGUAGE_NOT_PERSISTED',
} as const;

export type WhisperEventState = (typeof WhisperEventState)[keyof typeof WhisperEventState];
